import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { CurecallPaginationBar } from '@honestica/curecall-ui'
import { ExportReviewsModal } from './_components/export-reviews-modal.component'
import { PatientService } from 'src/services/patient.service'
import { TPatientReviewListRequest } from './_components/reviews.types'
import { useQuery } from '@tanstack/react-query'
import PatientReviewListTable from './_components/reviews-table.component'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PatientReviewHeader from './_components/reviews-header.component'
import DeprecatedReviewsPage from './_components/deprecated-patient-review'

export default function ReviewsPage() {
  const { project, isFeatureActivated } = useCurrentProject()

  const { t } = useTranslation()

  const [request, setRequest] = useState<TPatientReviewListRequest>({
    orderBy: { column: 'PatientReviewCreatedAt', descOrder: true },
    patientReviewsPerPage: 100,
    pageNumber: 1,
  })

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState<boolean>(false)

  const isNewReviewList = isFeatureActivated('NEW-PATIENT-REVIEW-LIST')

  const {
    isLoading: isLoadingStats,
    error: statsError,
    data: queryReviewStatsData,
  } = useQuery({
    queryKey: ['patient-reviews-stats'],
    queryFn: () => PatientService.getPatientReviewStats(project.id),
    enabled: isNewReviewList,
  })

  const {
    isLoading: isLoadingList,
    error: listError,
    data: queryReviewListData,
  } = useQuery({
    queryKey: ['patient-reviews-list', request],
    queryFn: () => PatientService.getPatientReviewList(project.id, request),
    enabled: isNewReviewList,
  })

  if (!isNewReviewList) {
    return <DeprecatedReviewsPage />
  }

  if (listError || statsError) {
    return <ErrorQueryHandler error={listError || statsError} />
  }

  return (
    <div className={'c-flex c-flex-col'}>
      <PatientReviewHeader
        isLoading={isLoadingStats}
        patientReviewStats={queryReviewStatsData}
        onExport={() => setIsDownloadModalOpen(true)}
      />
      <ExportReviewsModal
        onClose={() => setIsDownloadModalOpen(false)}
        isOpen={isDownloadModalOpen}
        projectId={project.id}
      />
      <>
        {!listError && !statsError && (
          <>
            <PatientReviewListTable
              patientReviewList={queryReviewListData?.patientReviews ?? []}
              isLoading={isLoadingList || isLoadingStats}
              currentOrder={request.orderBy}
              onTableHeaderClick={(orderBy) => {
                setRequest((prev) => ({ ...prev, orderBy }))
              }}
            />
            <CurecallPaginationBar
              totalItems={queryReviewListData?.totalPatientReviewsCount ?? 0}
              itemsPerPage={queryReviewListData?.patientReviewsPerPage}
              currentPage={queryReviewListData?.currentPage}
              numberOfVisiblePages={7}
              pagesLabel={t('common.actions.pages')}
              pageLabel={t('common.actions.page')}
              onClick={(pageNumber) => {
                setRequest((prev) => ({ ...prev, pageNumber }))
              }}
            />
          </>
        )}
      </>
    </div>
  )
}
